// import axios from "axios";
// import { showToast } from "../components/toast";
// import { API_URL } from "../config.js";

// const setupAxiosInterceptors = () => {
//   axios.interceptors.response.use(
//     (response) => response,
//     (error) => {
//       const status = error?.response?.status;

//       if (status === 401) {
//         // Token expired / Unauthorized
//         localStorage.removeItem("authToken");

//         showToast.error("Session expired. Please login again.");

//         // Force redirect to login
//         window.location.href = "/login";
//       }

//       return Promise.reject(error);
//     }
//   );
// };

// export default setupAxiosInterceptors;

import axios from "axios";
// import { showToast } from "../components/toast";
// import { API_URL } from "../config.js";

const setupAxiosInterceptors = () => {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      // const requestUrl = error?.config?.url;

      // ✅ Apply 401 logic specifically for expired JWT tokens
      if (status === 401 && error?.response?.data?.message === 'jwt expired') {
        localStorage.removeItem("authToken");
        localStorage.removeItem("user");
        sessionStorage.removeItem("subscriberFilterParams");
        localStorage.setItem("sessionExpired", "true");
        window.location.href = "/login";
      }

      return Promise.reject(error);
    }
  );
};

export default setupAxiosInterceptors;
